/**
 * Group List
 */

const Team =  [
    {
        id : 1,
        backgroundImg :'assets/images/small/img-9.jpg',
        userImage : 'assets/images/users/avatar-2.jpg',
        name : "Nancy Martino",
        jobPosition : "Team Leader & HR",
        projectCount :225,
        taskCount:197,
        isActive: false,
    },
    {
        id : 2,
        backgroundImg :'assets/images/small/img-12.jpg',
        userImage : null,
        userShortName :"HB",
        name : "Henry Baird",
        jobPosition : "Full Stack Developer",
        projectCount :352,
        taskCount:376,
        isActive: true,
    },
    {
        id : 3,
        backgroundImg :'assets/images/small/img-11.jpg',
        userImage : 'assets/images/users/avatar-3.jpg',
        name : "Frank Hook",
        jobPosition : "Project Manager",
        projectCount :162,
        taskCount:192,
        isActive: false,
    },
    {
        id : 4,
        backgroundImg :'assets/images/small/img-1.jpg',
        userImage : 'assets/images/users/avatar-8.jpg',
        name : "Jennifer Carter",
        jobPosition : "UI/UX Designer",
        projectCount :241,
        taskCount:205,
        isActive: true,
    },
    {
        id : 5,
        backgroundImg :'assets/images/small/img-1.jpg',
        userImage : null,
        userShortName :"ME",
        name : "Megan Elmore",
        jobPosition : "Team Leader & Web Developer",
        projectCount :201,
        taskCount:263,
        isActive: false,
    },
    {
        id : 6,
        backgroundImg :'assets/images/small/img-2.jpg',
        userImage : 'assets/images/users/avatar-4.jpg',
        name : "Alexis Clarke",
        jobPosition : "Backend Developer",
        projectCount :132,
        taskCount:147,
        isActive: false,
    },
    {
        id : 7,
        backgroundImg :'assets/images/small/img-4.jpg',
        userImage : '',
        userShortName :"NC",
        name : "Nathan Cole",
        jobPosition : "Front-End Developer",
        projectCount :352,
        taskCount:376,
        isActive: true,
    },
    {
        id : 8,
        backgroundImg :'assets/images/small/img-7.jpg',
        userImage : 'assets/images/users/avatar-6.jpg',
        name : "Joseph Parker",
        jobPosition : "Full Stack Developer",
        projectCount :64,
        taskCount:93,
        isActive: true,
    },
    {
        id : 9,
        backgroundImg :'assets/images/small/img-3.jpg',
        userImage : 'assets/images/users/avatar-5.jpg',
        name : "Erica Kernan",
        jobPosition : "Web Designer",
        projectCount :345,
        taskCount:298,
        isActive: false,
    },
    {
        id : 10,
        backgroundImg :'assets/images/users/avatar-5.jpg',
        userImage : null,
        userShortName :"DP",
        name : "Donald Palmer",
        jobPosition : "Wed Developer",
        projectCount :95,
        taskCount:135,
        isActive: true,
    },
    {
        id : 11,
        backgroundImg :'assets/images/small/img-8.jpg',
        userImage : 'assets/images/users/avatar-7.jpg',
        name : "Jack Gough",
        jobPosition : "React Js Developer",
        projectCount :87,
        taskCount:121,
        isActive: false,
    },
    {
        id : 12,
        backgroundImg :'assets/images/small/img-6.jpg',
        userImage : null,
        userShortName :"MW",
        name : "Marie Ward",
        jobPosition : "Backend Developer",
        projectCount :145,
        taskCount:210,
        isActive: false,
    },
  ]
  
  export { Team };
  